import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/complete')({
  component: AuthCompletePage
});

function AuthCompletePage(): React.ReactNode {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.opener) {
      window.close();
    } else {
      void navigate({ to: '/' });
    }
  }, [navigate]);

  return null;
}
